import React from "react";
import { SiteHeader } from "../components/header/SiteHeader";
import { AccidentHelp } from "../components/home/AccidentHelp";
import { CaseReviewSection } from "../components/home/CaseReviewSection";
import { CommonAnswers } from "../components/home/CommonAnswers";
import { CaseResult } from "../components/home/CaseResult";
import { MoreWins } from "../components/home/MoreWins";
import { Hero } from "../components/home/Hero";
import { TrustSection } from "../components/home/TrustSection";
import { RiderResources } from "../components/home/RiderResources";
import { SiteStatement } from "../components/SiteStatement";
import { SiteFooter } from "../components/SiteFooter";
type HomeProps = {
  showReviewNotes: boolean;
  showEmptyEvents: boolean;
};
export function Home({
  showReviewNotes
}: HomeProps) {
  return <div className="bold-home w-full bg-white text-ink" data-id="element-366" data-mp="3kuil9p1nz2bl">
    <a href="#main" className="sr-only left-4 top-4 z-50 bg-white px-5 py-3 font-bold text-ink focus:not-sr-only focus:absolute" data-id="element-367" data-mp="3owlwcckf84wc">Skip to main content</a>
    <SiteStatement data-id="element-368" data-mp="30w06053ths65" /><SiteHeader data-id="element-369" data-mp="30uoz3wf2s4at" />
    <main id="main" data-id="element-370" data-mp="2vxosnkebczj6"><Hero showReviewNotes={showReviewNotes} data-id="element-371" data-mp="2vx6s4bkmbz5g" /><CaseResult data-id="element-372" data-mp="2vy81mblzkdl2" /><MoreWins data-id="element-373" data-mp="2vvlvmgequ64y" /><TrustSection data-id="element-374" data-mp="2vvvnyan9gpdt" /><AccidentHelp data-id="element-375" data-mp="2qylsad9a3hhj" /><RiderResources data-id="element-376" data-mp="2qy2gzfe4vrch" /><CommonAnswers data-id="element-377" data-mp="2qxke3zwyuevl" /><CaseReviewSection data-id="element-378" data-mp="2qxapafnnqdrh" /></main>
    <SiteFooter data-id="element-379" data-mp="2r0gb9m0zoziz" />
  </div>;
}